import {
  registerComponent,
  asyncRequest,
  debounce,
  loading,
} from "helpers";
import {
  CART_SECTIONS_TO_RENDER,
  ensureCartFresh,
  getCartSectionNames,
  renderCartSections,
  updateCartCount,
} from "cart-refresh";

registerComponent(
  "cart-items",
  class CartItems extends HTMLElement {
    SECTIONS_TO_RENDER = CART_SECTIONS_TO_RENDER;

    constructor() {
      super();

      this.removeButtons = this.querySelectorAll("[data-remove-item-button]");
      this.form = this.querySelector("form");
      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]')
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0
      );

      this.removeButtons.forEach((button) => {
        button.addEventListener("click", this.remove.bind(this));
      });

      const debouncedChangeHandler = debounce((event) => {
        this.handleChange(event);
      }, 300);

      this.form?.addEventListener("change", debouncedChangeHandler);
    }

    remove(event) {
      const lineItemKey = event.currentTarget.dataset.removeItemButton;

      event.preventDefault();

      this.updateQuantity(lineItemKey, 0);
    }

    handleChange(event) {
      this.updateQuantity(
        event.target.dataset.lineItemKey,
        event.target.value
      );
    }

    getSectionNames() {
      return getCartSectionNames();
    }

    async updateQuantity(lineItemKey, quantity) {
      loading.add(this);

      const canUpdate = await ensureCartFresh(lineItemKey);

      if (!canUpdate) {
        loading.remove(this);
        return;
      }

      const body = {
        id: lineItemKey,
        quantity,
        sections: this.getSectionNames(),
        sections_url: window.location.pathname,
      };
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      const response = await asyncRequest(
        WYATT.routes.cart_change_url,
        options,
        {
          messageOptions: {
            dismiss: false,
            appendPoint:
              '[data-mini-cart][active="true"] [data-drawer-messages], #page-messages',
          },
        }
      );

      if (response) {
        this.handleSuccessfulUpdate(response);
      }

      loading.remove(this);
    }

    handleSuccessfulUpdate(state) {
      const parsedState = JSON.parse(state);

      window.WYATT.shopify.cart = parsedState;
      updateCartCount(parsedState);
      renderCartSections(parsedState.sections);
    }
  }
);
